import { css } from "@compiled/react";

import { AspectRatios, Image } from "@atlassiansox/wpl-image";

import {
    ContentBlock,
    OneButtonProps
} from "../../../../components/wpl/content-block/src";
import { Row, layout } from "../../../../libraries/wpl/foundations/src";

export type ImagePositions = "left" | "right";
type AlignTypes = "default" | "top" | "bottom" | "center";

export interface SideBySideProps {
    headerText: string | React.ReactNode;
    bodyText: string | React.ReactNode;
    imageLink: string;
    imageAltText: string;
    imagePosition?: ImagePositions;
    className?: string;
    ctaProps?: OneButtonProps;
    aspectRatio?: AspectRatios;
    horizontalRule?: boolean;
    alignItems?: AlignTypes;
    rowProps?: layout;
}
const heroStyle = css({
    "padding": "80px 0",
    "@media (min-width: 768px) and (max-width: 1023.98px)": {
        padding: "60px 0"
    },
    "@media (max-width: 767.98px)": {
        padding: "16px 0"
    }
});

export const SimpleImageTextSide = ({
    headerText,
    bodyText,
    imageLink,
    imageAltText,
    imagePosition,
    className = "",
    ctaProps,
    aspectRatio,
    horizontalRule = false,
    alignItems = "center",
    rowProps = "6-6"
}: SideBySideProps) => {
    let alignment = "1";
    if (imagePosition == "left") {
        alignment = "-1";
    }

    return (
        <div className={className} css={heroStyle}>
            <Row layout={rowProps} alignItems={alignItems}>
                <div>
                    <ContentBlock
                        headerText={headerText}
                        headerType="h2"
                        bodyText={bodyText}
                        ctaProps={ctaProps}
                        horizontalRule={horizontalRule}
                    />
                    <div
                        css={css({
                            "display": "flex",
                            ".image-text-side--text-input": {
                                height: "40px"
                            },
                            [`.image-text-side--text-input label[for="text-input"]`]:
                                {
                                    display: "none"
                                },
                            ".image-text-side--text-input div.input-container":
                                {
                                    height: "40px",
                                    marginInlineEnd: "16px"
                                },
                            ".image-text-side--text-input input": {
                                height: "40px"
                            }
                        })}
                    />
                </div>
                <Image
                    src={imageLink}
                    alt={imageAltText}
                    aspectRatio={aspectRatio || "none"}
                    css={css({ order: alignment })}
                />
            </Row>
        </div>
    );
};
